import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';
  import { themingCssClass } from "vue/applications/frontend/mixins/theming-mixin";

  import GenericAccordion from 'vue/applications/frontend/components/generic-accordion.vue';
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-accordion',
  props: {...cntProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "components__cnt-accordion",
    style: _normalizeStyle({'margin-left': _ctx.contentItem.widget_data.margin_left})
  }, [
    (_ctx.contentItem)
      ? (_openBlock(), _createBlock(GenericAccordion, { key: 0 }, {
          header: _withCtx(() => [
            _createElementVNode("h2", {
              class: _normalizeClass([_unref(themingCssClass)('normal_important')])
            }, _toDisplayString(_ctx.contentItem.widget_data.title), 3)
          ]),
          content: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentItem.child_content_items, (childItem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: childItem.id
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(childItem.widget_type), { "content-item": childItem }, null, 8, ["content-item"]))
              ]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})